import { CapoPlugin } from "/frontend/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.16_typescript@5.8.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];